const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  onPriceUpdate: "onPriceUpdate",
  onTitleUpdate: "onTitleUpdate",
  sellingPlanUpdate: "sellingPlanUpdate",
};

const ACCOUNT = {
  apiUrl:
    "https://repoocypnaiyjnhpkxlh.supabase.co/functions/v1/fetch-user-data",
  accessToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJlcG9vY3lwbmFpeWpuaHBreGxoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAxNTczMTcsImV4cCI6MjA0NTczMzMxN30.JT_GQAmjIT7IP685zeGvYrE6JhLDqBF9bTA-gScmpkU",
};
